import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";

import { selectUserId } from "fond/api";
import { useSwitchableAccounts } from "fond/hooks/useSwitchableAccounts";
import { Account, ExternalAccount } from "fond/types";
import { setAccountContext } from "fond/utils/accountContextStorage";
import { useAppSelector } from "fond/utils/hooks";
import { AccountAvatar } from "fond/widgets";
import { AccountContent } from "fond/widgets/AccountSwitch/AccountBox.styles";
import PageCentred from "fond/widgets/PageCentred/PageCentred";

const SelectAccount: FC = () => {
  const { accounts } = useSwitchableAccounts();
  const [selectedAccount, setSelectedAccount] = useState(accounts.at(0)?.ID || "");
  const userId = useAppSelector(selectUserId);

  useEffect(() => {
    // If we only have one account lets just select it and move on.
    if (accounts.length === 1 && userId) {
      setAccountContext(userId, accounts[0].ID);
    }
  }, [userId, accounts]);

  const handleOnClick = () => {
    if (userId && selectedAccount) {
      setAccountContext(userId, selectedAccount);
    }
  };
  const handleOnChange = (event: SelectChangeEvent<string>) => {
    setSelectedAccount(event.target.value);
  };

  const getAccount = (account: Account | ExternalAccount) => {
    return (
      <AccountContent key={account.ID}>
        <AccountAvatar account={account} variant="rounded" />
        <Typography>{account.Name}</Typography>
      </AccountContent>
    );
  };
  return (
    <PageCentred title="Select Workspace" icon={null} description="Please select the workspace you would like to view before proceeding.">
      <Select
        fullWidth
        defaultValue=""
        data-testid="select-account-select"
        value={selectedAccount}
        onChange={handleOnChange}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
            },
          },
        }}
      >
        {accounts.map((account) => (
          <MenuItem key={account.ID} value={account.ID}>
            {getAccount(account)}
          </MenuItem>
        ))}
      </Select>
      <Button fullWidth variant="contained" sx={{ my: 2 }} onClick={handleOnClick}>
        Continue
      </Button>
      <Typography component="p" variant="subtle" sx={{ textAlign: "center" }}>
        Or <Link to="/signout">sign out</Link> and log in with a different account if you don't see the workspace you're looking for.
      </Typography>
    </PageCentred>
  );
};

export default SelectAccount;
